



























import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class AppArcSelector extends Vue {
  @Prop({ type: Array }) readonly items!: string[]
  @Prop([Number, String]) readonly value!: number
  @Prop({ type: [Number, String], default: '204' }) readonly width!: number | string

  model = ''
  selectedIdx = -1

  showItems = false

  mounted () {
    this.onValueChanged(this.value)
  }

  @Watch('value')
  onValueChanged (val: number) {
    this.model = this.items[val] || ''
    return Number(val)
  }

  @Watch('model')
  onModelChanged () {
    this.selectHandler()
  }

  @Emit('input')
  valueChangeHandler (val: number) {
    this.model = this.items[val]
    this.selectedIdx = val
    this.showItems = false
    return this.selectedIdx
  }

  @Emit('select')
  selectHandler () {}

  showList () {
    this.showItems = true
  }

  hideList () {
    this.showItems = false
  }
}
